import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-footer',
  styleUrls: ['./footer.component.less'],
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  public readonly environment = environment;
}
